/** @flow */

import type { State } from "@store/reducers";
import type {
  MySavedReports,
  DefaultReports,
  AbsenceDetailsReportEmployee,
  AbsenceDetailsReportViewState,
} from "@modules/reporting/reducer/reports/absence-details/types";
import { getPagination } from "@selectors";
import type { PaginationExtendedType } from "@types";

export const absenceRecordSearchFiltersSchema = (state: State): Object =>
  state.reporting.reports.absenceDetails.absenceRecordSearchFiltersSchema;

export const defaultReports = (state: State): Array<DefaultReports> =>
  state.reporting.reports.absenceDetails.defaultReports;

export const mySavedReports = (state: State): Array<MySavedReports> => {
  return state.reporting.reports.absenceDetails.mySavedReports;
};

export const getReportDataPagination = (state: State): PaginationExtendedType =>
  getPagination(state.reporting.reports.absenceDetails.reportData);

export const getReportDataTotalElements = (state: State): number => {
  return state.reporting.reports.absenceDetails.reportData.totalElements;
};

export const getReportData = (state: State): Array<AbsenceDetailsReportEmployee> => {
  return state.reporting.reports.absenceDetails.reportData.content;
};

export type TypeAbsenceDetailsCurrentReport = {
  hidden: boolean,
  name: string,
  columns: string[],
  filters: {
    dateRange: string,
    absenceStatus?: string,
    absenceType?: string,
    absencesFilter: string,
    absenceReasons: { id?: number }[],
    absenceLength: ?string,
    showWorkRelatedOnly?: ?boolean,
    staffGroups: { id?: number }[],
    ageGroups: ?(string[]),
    absencesGreaterThanDayType?: string,
    gender?: string,
    fromDate: ?string,
    toDate: ?string,
    selectedOrganisationalUnitIds: ?(number[]),
    excludedOrganisationalUnitIds: ?(number[]),
    includeLeavers: ?boolean,
    includeEmployeesWithDisability: ?boolean,
    showConsentWithheldOnly?: ?boolean,
    absencesGreaterThanDays: number,
  },
};

export const getCurrentReport = (state: State): TypeAbsenceDetailsCurrentReport | null =>
  (state.reporting.reports.absenceDetails.currentReport || {}).report;

export const getCurrentCharts = (state: State): ?Object =>
  state.reporting.reports.absenceDetails.currentCharts;

export const getReportToSave = (state: State): ?Object =>
  state.reporting.reports.absenceDetails.reportToSave;
export const getViewState = (state: State): AbsenceDetailsReportViewState =>
  state.reporting.reports.absenceDetails.viewState;

export const isLoading = (state: State): boolean =>
  !!state.reporting.reports.absenceDetails.requestsInProgress;

export const isReportGenerateInProgress = (state: State): boolean =>
  !!state.reporting.reports.absenceDetails.reportGenerateInProgress;
